export default "__VITE_ASSET__BqOLd55I__"